import { useEffect, useRef, useState } from 'react';
import { checkIfInIframe } from 'utils/iframe';

const useDisableIframeFocus = () => {
  const [isInteracted, setIsInteracted] = useState(false);
  const originalFocus = useRef(HTMLElement.prototype.focus);

  useEffect(() => {
    const handleFirstClick = () => {
      setIsInteracted(true);
      document.removeEventListener('click', handleFirstClick);
    };
    
    document.addEventListener('click', handleFirstClick);
    
    return () => {
      document.removeEventListener('click', handleFirstClick);
    };
  }, []);

  useEffect(() => {
    const isInIframe = checkIfInIframe();
    const originalFocusMethod = originalFocus.current;

    if (isInIframe && !isInteracted) {
      HTMLElement.prototype.focus = () => {};
    } else {
      HTMLElement.prototype.focus = originalFocusMethod;
    }

    return () => {
      HTMLElement.prototype.focus = originalFocusMethod;
    };
  }, [isInteracted]);
};

export default useDisableIframeFocus;
